import placeholderImage from '../assets/images/placeholder-image.jpg';
import { API_BASE_URL } from '../config/api';

export const toHttps = (url) => {
  if (!url) return null;
  if (typeof url !== "string") return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const base = API_BASE_URL ? String(API_BASE_URL).replace(/\/$/, "") : "";
  if (url.startsWith("/")) return base + url;
  return `${base}/${url}`;
};

export const handleImageError = (e) => {
  e.target.src = placeholderImage;
  e.target.onerror = null; // Prevent infinite loop
};

export const getImageUrl = (url) => {
  return toHttps(url) || placeholderImage;
}; 
